export function mapTimeValueToSeconds(value) {
    const values = value.split(':');
    if (values.length === 2) {
        return +values[0] * 60 + +values[1];
    }
    return 0;
}

export function mapSecondsToTimeValue(seconds, withHours = false) {
    const hoursPart = Math.floor(seconds / 3600);
    const minutesPart = Math.floor((withHours ? seconds % 3600 : seconds) / 60);
    const secondsPart = Math.round(seconds % 60);
    return (
        (withHours ? `${hoursPart.toString().padStart(2, '0')}:` : '') +
        `${minutesPart.toString().padStart(2, '0')}:${secondsPart.toString().padStart(2, '0')}`
    );
}

export function addDurationToTimeValue(timeStr, duration) {
    // 1. Разбиваем строку '13:00' на часы и минуты
    const [hours, minutes] = timeStr.split(':').map(Number);

    // 2. Переводим всё в секунды с начала дня
    const totalSeconds = (hours * 3600) + (minutes * 60) + duration;

    // 3. Вычисляем новые часы и минуты (используем % 86400, чтобы время "обнулялось" через полночь)
    const newHours = Math.floor((totalSeconds % 86400) / 3600);
    const newMinutes = Math.floor((totalSeconds % 3600) / 60);

    // 4. Форматируем результат с добавлением ведущих нулей
    return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
}